import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Show an error if a project is not found.
 */
const UnkownProject = () => (
  <div className='project-missing-error flex h-full items-center justify-center text-center'>
    <p>We're sorry but we can't find that model.<br/>
    Go back to your <Link to='/'>Dashboard</Link>.</p>
  </div>
);

export default UnkownProject;
